import { colors } from '@components/theme/styles/index';
import { styled } from '@mui/material';
import { rem, transparentize } from 'polished';

export const StyledToolbarPlugin = styled('div')({
  display: 'grid',
  backgroundColor: colors.grayLight3,
  color: colors.grayDark2,
  borderBottom: `1px solid ${colors.grayLight1}`,
});

export const StyledFormatGroup = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const StyledFormatButton = styled('button')<{ $active?: boolean }>(
  ({ $active }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: rem(12),
    border: 'none',
    backgroundColor: 'transparent',
    color: colors.grayDark2,

    ...($active && {
      backgroundColor: transparentize(0.5, colors.grayLight1),
    }),

    '&:hover': {
      cursor: 'pointer',
    },
  }),
);
